import { AxiosResponse } from "axios";
import { BasicQueryType, MutationBasicaParam } from "../../../Utils/RequisicaoUtilitario";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Axios } from "../../Axios";
import { queryClient } from "../../../App";
import Titulo from "@/Models/Financeiro/Titulo/Titulo";

// export function useFaturaListar({
//     nota,
//     dataCompetenciaInical,
//     dataCompetenciaFinal,
//     ativo,
//     onFinish,
//     ...rest
// }:QueryBasicaParam<AxiosResponse<Nota[]>, Nota[], {
//     nota?:Nota,
//     dataCompetenciaInical?:dayjs.Dayjs,
//     dataCompetenciaFinal?:dayjs.Dayjs,
//     ativo?:boolean,
//     onFinish:() => void
// }>) {
//     const queryString = RequestUtilitario.objectToQueryString({
//         ...(nota ?? {}),
//         dataCompetenciaInical: dataCompetenciaInical?.toDate().toJSON(),
//         dataCompetenciaFinal: dataCompetenciaFinal?.toDate().toJSON(),
//         ativo
//     });

//     return useQuery({
//         ...rest,
//         queryKey : ["Financeiro", "Titulo", "Nota", "Listar", queryString ],
//         queryFn : () => Axios.get<Nota[]>(`financeiro/titulo/nota?${queryString}`).finally(() => onFinish?.()),
//         select(data) {
//             return data.data.map(m => {
//                 m.dataCriacao = new Date(m.dataCriacao as any);
//                 m.dataCompetencia = new Date(m.dataCompetencia as any);
//                 return m;
//             })
//         },
//     });
// }

export function useFaturaSalvar({
    onSuccess,
    ...rest
}:MutationBasicaParam<
    { fatura:Titulo, isAlteracao:boolean, isAReceber:boolean }, 
    AxiosResponse<void>|AxiosResponse<number>
>) {
    return useMutation({
        ...rest,
        mutationFn : ({
            fatura,
            isAlteracao,
            isAReceber
        }) => {
            if (isAlteracao)
                return Axios.put<void>(`financeiro/titulo/fatura/${fatura.codigo}`, fatura)
            else
                return Axios.post<number>(isAReceber ? "financeiro/titulo/fatura/a-receber" : "financeiro/titulo/fatura/a-pagar", fatura);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Financeiro", "Titulo", "Fatura"] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useFaturaDesativar({
    onSuccess,
    ...rest
}:MutationBasicaParam<number, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn: (codigo) => {
            return Axios.delete<void>(`financeiro/titulo/fatura/${codigo}`);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Financeiro", "Titulo", "Fatura"] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useFaturaAtivar({
    onSuccess,
    ...rest
}:MutationBasicaParam<number, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn: (codigo) => {
            return Axios.patch<void>(`financeiro/titulo/fatura/${codigo}/ativar`);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Financeiro", "Titulo", "Fatura"] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useFaturaBuscar({
    codigo,
    ativo,
    select,
    ...rest
}:BasicQueryType<AxiosResponse<Titulo|null>, {
    codigo:number,
    ativo?:boolean|null
}>) {
    ativo = ativo === undefined ? true : ativo;

    return useQuery({
        ...rest,
        queryKey : ["Financeiro.Titulo.Listar", `Financeiro.Titulo.Buscar.${codigo}?ativo=${ativo}`],
        queryFn : () => Axios.get<Titulo|null>(`financeiro/titulo/fatura/${codigo}?ativo=${ativo ?? ''}`),
        select : (response) => {
            let data = response.data ?? null;
            
            if (data != null)
            {
                data.dataEmissao = new Date(data.dataEmissao as any);
                data.dataVencimento = new Date(data.dataVencimento as any);
                data.dataCriacao =  new Date(data.dataCriacao as any);
            }

            data = data ?? null as Titulo|null;
            
            response = select?.(response) ?? response;
            
            return response;
        },
        staleTime : 1000 * 60 * 0.08 // 5 segundos
    });
}